export default "__VITE_ASSET__17a368b0__"